import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SetField } from '../components/Table/fields/SetField';
import { service } from './service';
import { Group } from '../types/entities/Group';
import { SelectField } from '../components/Table/fields/SelectField';
import { activity } from './activity';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { CustomFieldForServices } from '../components/Table/fields/CustomFieldForServices';

export const servicePackage = (
  forGroupId?: Group['id']
): SchemaWithClient<any> => ({
  name: 'Service Group',
  pluralName: 'Service Group',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Service Group Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      required: true,
    },
    activity: {
      name: 'Activity',
      fieldRenderer: SelectField.tableAdapter(activity),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(activity),
      url: activity.client.getAllPath,
      tempSchema: activity,
      switchboard: true,
      readOnly: true,
    },
    /* service_provider: {
      name: 'Service Provider (▼)',
      fieldRenderer: SelectField.tableAdapter(serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(serviceProvider),
      url: serviceProvider.client.getAllPath,
      tempSchema: serviceProvider,
      switchboard: true,
    },*/
    /* services: {
      name: 'Services',
      fieldRenderer: SetField.tableAdapter(service),
      slidePaneFieldRenderer: SPSetFieldWithMoreOptions.tableAdapter(
        service,
        true
      ),
      url: service.client.getAllPath,
      tempSchema: service,
      multiSwitchboard: true,
      accordingTo: 'service_provider',
    },*/

    services: {
      name: 'Services',
      fieldRenderer: SetField.tableAdapter(service),
      slidePaneFieldRenderer: CustomFieldForServices,
      url: service.client.getAllPath,
      tempSchema: service,
      multiSwitchboard: true,
      withoutNameColumn: true,
    },

    /*
    stripper_roles_with_count: {
      name: 'Artist Roles',
      fieldRenderer: SetField.tableAdapter(enumItems.subRole),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.subRole, true),
      url: enumItems.subRole.client.getAllPath,
      tempSchema: enumItems.subRole,
      multiSwitchboard: true,
    },

    guide_hour: {
      name: 'Guide Wage',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },*/

    extra: {
      name: 'Extra',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    assigned_staff: {
      name: 'Assigned Staff',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client(
    '/service-packages',
    forGroupId !== undefined
      ? `/groups/${forGroupId}/service-packages`
      : undefined
  ),
});
